import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Color, Size } from '../../../../const'
import Alert from 'components/Alert'
import _ from 'lodash'

import { useAccountHook } from '../../../../hooks'
import { Banner, Button, Checkbox, Logout } from 'components/shard'
import { WithdrawConfirmModal } from '../../common/WithdrawConfirmModal'
import serviceAPI from 'utils/axios/modules/service'
import { useLoginCallbackHook } from 'hooks'
import WrapperLink from 'components/shard/WrapperLink'

function Account() {
  const {
    user,
    isIdle,
    isLoading,
    errors,
    setErrors,
    approvalDm,
    execGetUser,
    execUpdateApprovalDm,
    goToUserCreditCardURL,
    goToServiceList,
    goToEditAccount,
    goToEditTanakaId,
  } = useAccountHook()

  useEffect(() => {
    execGetUser()
  }, [execGetUser])

  const headingElement = (
    <Heading>
      <div>
        <span>※NINAL登録クレジットカード変更は</span>
        <HeadingLink as="div" role="button" tabIndex={0} onClick={goToServiceList}>
          コチラ
        </HeadingLink>
      </div>
      <div>
        <span>※ウェブショップ登録クレジットカードの変更は</span>
        <HeadingLink as="div" role="button" tabIndex={0} onClick={goToUserCreditCardURL}>
          コチラ
        </HeadingLink>
      </div>
    </Heading>
  )

  return (
    <Wrapper>
      {headingElement}
      {isIdle || isLoading ? (
        <AccountBlock>
          <Caution>アカウント情報を取得中です...</Caution>
        </AccountBlock>
      ) : (
        <AccountDisplay
          user={user}
          errors={errors}
          setErrors={setErrors}
          approvalDm={approvalDm}
          execUpdateApprovalDm={execUpdateApprovalDm}
          goToEditAccount={goToEditAccount}
          goToEditTanakaId={goToEditTanakaId}
        />
      )}
      <Banner />
      <Logout />
    </Wrapper>
  )
}

function AccountDisplay({
  user,
  errors,
  setErrors,
  approvalDm,
  execUpdateApprovalDm,
  goToEditAccount,
  goToEditTanakaId,
}) {
  const [isWithdrawConfirmModalOpen, setIsWithdrawConfirmModalOpen] = useState(false)
  const { resetStorageFunc } = useLoginCallbackHook()

  /* 退会ができるかどうかの確認 */
  const withdrawConfirm = async () => {
    try {
      const response = await serviceAPI.getCanWithdraw()
      if (response.data) {
        setIsWithdrawConfirmModalOpen(true)
      }
    } catch (error) {
      setErrors([error])
    }
  }

  /* 退会処理 */
  const withdraw = async () => {
    try {
      const response = await serviceAPI.postWithdraw()
      if (response.data) {
        resetStorageFunc()

        window.location =
          process.env.REACT_APP_SSO_LOGOUT_URL +
          encodeURIComponent(window.location.protocol + '//' + window.location.host + '/ninal/mypage/login')
      }
    } catch (error) {
      setErrors([error])
    }
  }

  return (
    <React.Fragment>
      {errors.length > 0 && (
        <Alert type="error" message="エラー" description={errors.join('\n')} onClose={() => setErrors([])} />
      )}
      <AccountBlock>
        {_.isEmpty(user) ? (
          <p>アカウント情報がありません</p>
        ) : (
          <React.Fragment>
            <ListLabelArea>
              <TanakaLabel>アカウント情報</TanakaLabel>
              <ListLabelLink>
                <EditLink as="div" onClick={goToEditTanakaId}>
                  編集する
                </EditLink>
              </ListLabelLink>
            </ListLabelArea>
            <TextArea1>
              <IdEmailLabel>TANAKA-ID</IdEmailLabel>
              <IdEmailArea>
                <IdEmailWrapper>
                  <IdEmail>{user.tanaka_id}</IdEmail>
                </IdEmailWrapper>
              </IdEmailArea>
            </TextArea1>
            <Separator />
            <MarginArea />
            <ListLabelArea>
              <ListLabel>お客様情報</ListLabel>
              <ListLabelLink>
                <EditLink as="div" onClick={goToEditAccount}>
                  編集する
                </EditLink>
              </ListLabelLink>
            </ListLabelArea>
            <TextArea2>
              <NameLabel>氏名</NameLabel>
              <NameArea>
                <NameWrapper>
                  <Name>
                    {user.lastname} {user.firstname}
                  </Name>
                  <Kana>
                    {user.lastname_kana} {user.firstname_kana}
                  </Kana>
                </NameWrapper>
              </NameArea>
              <AddressLabel>住所</AddressLabel>
              {!_.isEmpty(user.addresses) && (
                <Address>
                  〒{user.addresses.address1.zipcode}　{user.addresses.address1.state}
                  {user.addresses.address1.city}
                  {user.addresses.address1.address1}
                  {user.addresses.address1.address2}
                  {user.addresses.address1.address3}
                </Address>
              )}
              <TellLabel>連絡先</TellLabel>
              <Tell>
                {user.telephone && <TellContent>電話番号：{user.telephone}</TellContent>}
                {user.mobilephone && <TellContent>携帯電話番号：{user.mobilephone}</TellContent>}
              </Tell>
              <EmailLabel>メールアドレス</EmailLabel>
              <EmailValue>{user.emailaddress1 || ''}</EmailValue>
            </TextArea2>
            <Separator />
            <MarginArea />
            <ListLabelArea>
              <ListLabel>お知らせメールの配信とはがきの送付</ListLabel>
            </ListLabelArea>
            <TextArea3>
              <CheckboxArea>
                <Checkbox
                  check={approvalDm === true}
                  onClick={() => {
                    if (approvalDm === false) execUpdateApprovalDm(true)
                  }}
                />
              </CheckboxArea>
              <CheckboxLabel>希望する</CheckboxLabel>
              <CheckboxArea>
                <Checkbox
                  check={approvalDm === false}
                  onClick={() => {
                    if (approvalDm === true) execUpdateApprovalDm(false)
                  }}
                />
              </CheckboxArea>
              <CheckboxLabel>希望しない</CheckboxLabel>
              <Notes>
                ※保書期間のお知らせや、NINAL（ニナル）契約に関するお知らせは配信停止できませんので、あらかじめご了承ください。
                <br />
                ※配信停止には数日かかる場合があり、停止後もメールが配信される可能性がございます。
              </Notes>
            </TextArea3>
          </React.Fragment>
        )}
      </AccountBlock>
      <ButtonWrapper>
        <Button fontSize={Size.FONT.BIGGER} onClick={withdrawConfirm}>
          退会する
        </Button>
      </ButtonWrapper>
      <WithdrawalCaution>
        <p>
          ※NINAL契約中の方は、NINAL契約終了までは退会できません。 <br /> ※My TANAKA会員サービスについて詳しくは
          <a href="https://www.tanaka-megane.co.jp/mytanaka/" target="_blank" rel="noopener noreferrer">
            コチラ
          </a>
        </p>
      </WithdrawalCaution>
      <WithdrawConfirmModal
        display={isWithdrawConfirmModalOpen}
        yesButtonClick={withdraw}
        noButtonClick={() => setIsWithdrawConfirmModalOpen(false)}
      />
    </React.Fragment>
  )
}

const Wrapper = styled.div``
const AccountBlock = styled.div`
  padding: 53px 24px 42px 24px;
  border-radius: 10px;
  border: 1px solid ${Color.LINE.NORMAL};
  margin-bottom: 60px;
`
const Caution = styled.div`
  margin: 20px 0 30px;
`
const ListLabelArea = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  padding-bottom: 23px;
`
const ListLabelStyle = `
  grid-column: 1;
  font-weight: 700;
`

const TanakaLabel = styled.div`
  font-size: ${Size.FONT.LG};
  ${ListLabelStyle};
`
const ListLabel = styled.div`
  font-size: ${Size.FONT.BIGGER};
  ${ListLabelStyle};
`
const ListLabelLink = styled.div`
  grid-column: 2;
  font-size: ${Size.FONT.REGULAR};
`
const EditLink = styled(WrapperLink)`
  font-size: ${Size.FONT.NORMAL};
  text-decoration: none;
  font-weight: 700;
  cursor: pointer;
`
const TextArea = `
  display: grid;
  grid-template-columns: 36px 101px 1fr;
`
const TextLabel = `
  grid-column: 1 / 3;
  font-size: ${Size.FONT.BIG};
  display: grid;
  align-items: center;
  font-weight: 700;
`
const Text = `
  grid-column: 3;
  font-size: ${Size.FONT.BIGGER};
  display: grid;
  align-items: center;
  font-weight: 500;
`
const TextArea1 = styled.div`
  ${TextArea}
  grid-template-rows: 70px;
  padding-bottom: 21px;
  padding-left: ${Size.PADDING.APP};
`
let RowNum = 1
const IdEmailLabel = styled.div`
  grid-row: ${RowNum};
  ${TextLabel}
`
const IdEmailArea = styled.div`
  grid-row: ${RowNum};
  ${Text}
`
const IdEmailWrapper = styled.div``
const IdEmail = styled.div`
  float: left;
  padding-right: 27px;
`
RowNum = 2
const Separator = styled.hr`
  border-top: 1px solid ${Color.LINE.NORMAL};
  border-bottom: 0;
  margin: 0;
`
const MarginArea = styled.div`
  padding-bottom: 53px;
`
const TextArea2 = styled.div`
  ${TextArea}
  grid-template-rows: 70px 70px 70px 70px;
  padding-bottom: 21px;
  padding-left: ${Size.PADDING.APP};
`
RowNum = 1
const NameLabel = styled.div`
  grid-row: ${RowNum};
  ${TextLabel}
`
const NameArea = styled.div`
  grid-row: ${RowNum};
  ${Text}
`
const NameWrapper = styled.div``
const Name = styled.div`
  float: left;
  padding-right: 20px;
  font-size: ${Size.FONT.BIGGER};
`
const Kana = styled.div`
  float: left;
  font-size: ${Size.FONT.NORMAL};
  padding-top: 4px;
  font-weight: 500;
`
RowNum = 2
const AddressLabel = styled.div`
  grid-row: ${RowNum};
  ${TextLabel}
`
const Address = styled.div`
  grid-row: ${RowNum};
  ${Text}
`
RowNum = 3
const TellLabel = styled.div`
  grid-row: ${RowNum};
  ${TextLabel}
`
const Tell = styled.div`
  grid-row: ${RowNum};
  ${Text}
`
const EmailLabel = styled.div`
  grid-row: 4;
  ${TextLabel}
`

const EmailValue = styled.div`
  grid-row: 4;
  ${Text}
`
const TellContent = styled.div``
const TextArea3 = styled.div`
  padding-left: ${Size.PADDING.APP};
  ${TextArea}
`
const CheckboxArea = styled.div`
  grid-column: 1;
  padding: 14px;
`
const CheckboxLabel = styled.div`
  grid-column: 2 / 4;
  font-size: ${Size.FONT.BIGGER};
  padding: 10px 14px;
  font-weight: 700;
`
const Notes = styled.div`
  grid-column: 1 / 4;
  font-size: ${Size.FONT.NORMAL};
  padding-top: 16px;
  font-weight: 500;
`
const ButtonWrapper = styled.div`
  text-align: center;
  margin-top: 40px;
`
const WithdrawalCaution = styled.div`
  ${TextLabel}
  margin: 16px 0 60px;
  font-weight: 500;
  > p {
    width: 452px;
    margin: 0 auto;
    line-height: 1.85rem;
    letter-spacing: 0 !important;
    font-size: ${Size.FONT.NORMAL};
    > a {
      text-decoration: underline;
      display: inline-block;
    }
  }
`

const Heading = styled.h5`
  font-weight: 700;
  color: ${Color.FONT.ANNOTATION_RED};
  padding-bottom: 30px;
  font-size: ${Size.FONT.BIG};

  a {
    color: inherit;
    text-decoration: underline;
  }

  span {
    color: inherit;
  }

  div[role='button'] {
    display: inline-block;
    text-decoration: underline;
  }
`

const HeadingLink = styled.a`
  cursor: pointer;
  display: inline-block;
`

AccountDisplay.propTypes = {
  user: PropTypes.object,
}

export default Account
